
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/simulator",
      function () {
        return require("private-next-pages/simulator/index.tsx");
      }
    ]);
  